"use strict";

exports.__esModule = true;
exports.useToolbar = void 0;

var _react = require("react");

var _platform = _interopRequireDefault(require("platform"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useToolbar = ({
  download,
  blob,
  fullScreen,
  onToggleFullScreen,
  setTimeout
}) => {
  const iframeRef = (0, _react.useRef)(null);
  const [objectURL, setObjectURL] = (0, _react.useState)(null);
  const [showPrintUnsupportedModal, setShowPrintUnsupportedModal] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    if (objectURL) {
      iframeRef.current.src = objectURL;
    }
  }, [objectURL]); // if a objectURL was created then revoke it when unmounting the component to clean up memory allocation

  (0, _react.useEffect)(() => {
    return () => {
      if (objectURL) {
        window.URL.revokeObjectURL(objectURL);
      }
    };
  }, []);
  /**
   * Download a document from the modal and handle close as well
   */

  const downloadFromModal = (0, _react.useCallback)(() => {
    download();
    setShowPrintUnsupportedModal(false);
  }, []);
  /**
   * Toggle the print state to render the iframe
   */

  const printDocument = (0, _react.useCallback)(() => {
    // If IE or Firefox then show the print unsupported modal because we know
    // the browser can't handle printing loading the blob in an iframe src
    if (_platform.default.name === 'IE' || _platform.default.name === 'Firefox') {
      setShowPrintUnsupportedModal(true);
    } else {
      if (!iframeRef.current) {
        iframeRef.current = document.createElement('iframe');
        document.body.appendChild(iframeRef.current);
        iframeRef.current.style.display = 'none';

        iframeRef.current.onload = () => {
          setTimeout(() => {
            iframeRef.current.focus();
            iframeRef.current.contentWindow.print();
          }, 1);
        };
      }

      setObjectURL(window.URL.createObjectURL(blob));
    }
  }, [iframeRef, setTimeout, objectURL, setObjectURL, blob]);
  /**
   * Toggle the print unsupported modal open if not supported
   */

  const closePrintUnsupportedModal = (0, _react.useCallback)(() => {
    setShowPrintUnsupportedModal(false);
  }, [setShowPrintUnsupportedModal]);
  /**
   * Toggle full screen mode
   */

  const toggleFullscreen = (0, _react.useCallback)(() => {
    onToggleFullScreen(!fullScreen);
  }, [onToggleFullScreen, fullScreen]);
  return {
    printDocument,
    showPrintUnsupportedModal,
    closePrintUnsupportedModal,
    downloadFromModal,
    toggleFullscreen
  };
};

exports.useToolbar = useToolbar;